module.exports = __webpack_public_path__ + "img/candy.e19f4b03.jpg";